module.exports = __webpack_public_path__ + "static/media/ImpactStoryLogoGyeongsangbukDo.f3c98074.png";